import { memo } from 'react';
import type { FC } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export interface CameraCardHeaderProps {
  cameraName: string;
  shouldShowCountingIndicator: boolean;
  isMobile?: boolean;
}

export const CameraCardHeader: FC<CameraCardHeaderProps> = memo(
  ({
    cameraName,
    shouldShowCountingIndicator,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- kept for API compatibility
    isMobile: _isMobile = false,
  }) => {
    return (
      <div style={{ padding: '2.84% 5.68% 0 5.68%' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '3.41%',
            justifyContent: 'flex-start',
          }}
        >
          {shouldShowCountingIndicator && (
            <div
              style={{
                width: 'clamp(6px, 4.55cqi, 18px)',
                height: 'clamp(6px, 4.55cqi, 18px)',
                borderRadius: '50%',
                backgroundColor: '#ff4d4f',
                flexShrink: 0,
              }}
            />
          )}
          <Text
            style={{
              color: '#6b7280',
              fontWeight: 700,
              fontSize: 'clamp(10px, 6.82cqi, 24px)',
              textTransform: 'none',
            }}
          >
            {cameraName}
          </Text>
        </div>
      </div>
    );
  }
);

CameraCardHeader.displayName = 'CameraCardHeader';
